var venue_id = "eu-es-00040-realmadrid";
var topview_id = "V_blockmap";
var map_id_mini = "V_blockmap_minimap";
var popover_timeout = null;
var url = null;
var current_view = "map";

interfaceSetTicketsURL(url);


/* D2M */
var instance_options = {
    version: "latest",
    plugins:['best_nodes'],
    container: "viewer",
    callbacks: {
        click: onClickCB,
        enter: onEnterCB,
        leave: onLeaveCB,
        zooming: onZoomCB
    }
};

var instance_options_mini = {
    container: "blockmap-mini"
};

var viewer3d_input_options = {
    container: "view3d",
    plugins: ['gallery','indoor','navigation'],
    callbacks: {
        fullscreen_enabled: result => {
            $(".fsclose-btn").removeClass("hidden");
        },
        fullscreen_disabled: result => {
            $(".fsclose-btn").addClass("hidden");
        },
        click_navigation_node: dvmViewer3dOnClickNavNode
    }
};

var viewer_promise = DVM.loadModule("map_viewer", instance_options);
var viewer_mini_promise = DVM.loadModule("map_viewer", instance_options_mini);
var viewer_3d_promise = DVM.loadModule("3d_viewer", viewer3d_input_options);
var filtering = $.getJSON("src/js/dataconfig/filtering/filtering.json");
var navigation = $.getJSON("src/js/dataconfig/navigation/navigation.json");
if(interf.params.iframe && interf.params.iframe==='true'){
    interfaceSetIframe();
}

Promise.all([viewer_promise, viewer_mini_promise, viewer_3d_promise,filtering,navigation])
    .then(function(result) {
        viewer = result[0];
        viewer_mini = result[1];
        viewer_3d= result[2];
        
        filtering = result[3];
        navigation = result[4];

        dvmBindInterfaceEvents();
        dvmSetInitialFlags();
        dvmStart();
    })
    .catch(function(err) {
        console.error(err);
    });

